<template>
  <a-button @click="visible = true"><slot>导入</slot></a-button>

  <a-modal
    v-model:visible="visible"
    class="organization-import--modal"
    title="导入数据"
    width="65%"
    :footer="false"
    :destroy-on-close="true"
    :after-close="closeModal"
  >
    <div class="scroll-container">
      <a-steps :current="currentStep">
        <a-step title="选择EXCEL表" />
        <a-step title="数据预览" />
        <a-step title="导入校验" />
        <a-step title="导入数据" />
      </a-steps>

      <select-file
        v-if="currentStep === 0"
        :loading-request="loading"
        :model-url="modelUrl"
        :templateKey="templateKey"
        @finishUpload="finishUpload"
      >
        <template #standard>
          <slot name="limit">
            <p>上传的Excel表符合以下规范:</p>

            <p>● 文件大小不超过10M，且单个sheet页数据量不超过200行</p>
            <p>● 仅支持(.xls和*.xlsx)文件</p>
            <p>● 请确保您需要导入的sheet表头中不包含空的单元格，否则该sheet页数据系统将不做导入</p>
            <p>● 批量导入的数据不支持以“内置变量”作为条件的过滤</p>
            <p>● 导入文件不支持Excel公式计算，如SUM(A1:B3 A2:C2)等</p>
            <p>
              ●
              导入文件会覆盖已有往来单位信息，如需更新已有往来单位，请先导出数据，在导出表格里进行修改后再上传
            </p>
          </slot>
        </template>
      </select-file>

      <data-preview
        v-if="currentStep === 1"
        :data="tableData"
        :columns="columns"
        :tableHeight="tableHeight"
        @set-steps="setSteps"
      />
      <data-valid
        v-if="currentStep === 2"
        :data="data"
        :columns="columns"
        :tableHeight="tableHeight"
        :upload-api-fn="uploadApiFn"
        :isExtraUploadApiFn="isExtraUploadApiFn"
        :extraUploadApiFn="extraUploadApiFn"
        @set-steps="setSteps"
        :checkType="checkType"
        :checkKey="tableData?.exportKey"
      />
      <finish-import
        v-if="currentStep === 3"
        :back-page="backPage"
        @handle-close="visible = false"
      />
    </div>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  isGlobal: true,
  name: "MultipleImport",
});
</script>

<script lang="ts" setup>
import { ref, onMounted, computed, onUnmounted } from "vue";
import SelectFile from "./select-file.vue";
import DataPreview from "./data-preview.vue";
import DataValid from "./data-valid.vue";
import FinishImport from "./finish-import.vue";
import NP from "number-precision";
import { debounce } from "lodash";

const props = defineProps({
  checkApiFn: {
    type: Function,
    required: true,
  },
  uploadApiFn: {
    type: Function,
    required: true,
  },
  extraUploadApiFn: {
    type: Function,
  },
  backPage: {
    type: String,
    required: true,
  },
  modelUrl: {
    type: String,
  },
  columns: {
    type: Array,
    default: () => [],
  },
  templateKey:{
    type: String,
  },
  checkType: {
    type: String,
  },
  isExtraUploadApiFn:{
    type: Boolean,
    default:false
  }
});

const emit = defineEmits(["refresh"]);

const visible = ref(false);

const currentStep = ref(0);

const { run, data, loading } = props.checkApiFn();

const tableData = computed(() => {
  return {
    failList: data?.value?.failList?.slice(0, 100) || [],
    originalList:
      data?.value?.originalList?.slice(0, 100) || data?.value?.initialList?.slice(0, 100) || [],
    passList: data?.value?.passList?.slice(0, 100) || [],
    exportKey:data?.value?.exportKey
  };
});

async function finishUpload(url) {
  if (url && run) {
    const res = await run(url);
    if (res?.respCode === "0000") {
      currentStep.value = 1;
    }
  }
}

function setSteps(step: number) {
  currentStep.value = step;
  if (step === 3) {
    emit("refresh");
  }
}

const tableHeight = ref(200);
function calcTableHeight() {
  const doumentHeight = window.innerHeight > 1000 ? 1000 : window.innerHeight;

  const calcHeight = NP.minus(NP.times(doumentHeight, 0.8), 235);
  tableHeight.value = calcHeight > 200 ? calcHeight : 200;
}
onMounted(() => {
  calcTableHeight();
});

const deCalcTableHeight = debounce(calcTableHeight, 200);

window.addEventListener("resize", deCalcTableHeight);

function closeModal() {
  currentStep.value = 0;
  data && (data.value = undefined);
}

onUnmounted(() => {
  window.removeEventListener("resize", deCalcTableHeight);
});
</script>

<style lang="less">
.organization-import--modal {
  .ant-steps {
    margin-bottom: 20px;
    padding: 0 60px;
  }

  .ant-modal-content {
    max-height: 80vh;
  }
  .ant-modal-body {
    max-height: calc(80vh - 55px);
    padding: 20px 0;
    overflow: hidden;
    .scroll-container {
      max-height: calc(80vh - 95px);
      box-sizing: border-box;
      overflow-y: auto;
    }
  }
}
</style>
